import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getFxtEdition } from "@/js/pages/product/rackbuilder/utils/fxt-utils"
import { getCommonAccessorySelections, getBackSelection, getFrontSelection, getJCupSelection, getDepthSelection, getPlateStorageSelection, getBandPegSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

// MARK: FM-6/FML-6
export function createStandardConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const rackSku = rogue.getProductById(buyRequest.productId).sku
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'functional trainer')
  const edition = functionalTrainer?.attributes?.edition?.toString().toLowerCase() || ''
  const line = rackSku.startsWith('FML') || rackSku.includes('RML') ? 'RML' : 'RM'

  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  return {
    ...sharedConfig,
    back         : getBackSelection(rogue, buyRequest, meta) || 'nameplate',
    front        : getFrontSelection(rogue, buyRequest, meta),
    edition      : getFxtEdition(edition),
    jcup         : getJCupSelection(rogue, buyRequest),
    depth        : getDepthSelection(rack, meta),
    sixPost      : true,
    plateStorage : getPlateStorageSelection(rogue, buyRequest),
    bandPegs     : getBandPegSelection(rogue, buyRequest),
    ftShrouds    : Boolean(functionalTrainer?.attributes?.rig_or_wm === 'Yes'),
    spotterArms  : getAccessoryQuantity(rogue, buyRequest, 'spotter arms'),
    trolleySelection,
    latBarSelection,
    lowRowSelection,
  }
}
